const getApiUrl = () => {
  // 1. Use REACT_APP_API_URL from .env (recommended)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // 2. Build URL from individual env vars
  const port = process.env.REACT_APP_API_PORT || '8002';
  const host = process.env.REACT_APP_API_HOST || 'localhost';
  const protocol = process.env.REACT_APP_API_PROTOCOL || 'http';

  return `${protocol}://${host}:${port}/api`;
};

export const API_URL = getApiUrl();

export const CONFIG = {
  API_URL,
  APP_NAME: 'Milk Agency Management System',
  VERSION: '1.0.0',
  DEFAULT_PAGE_SIZE: 10,
  DATE_FORMAT: 'YYYY-MM-DD',
  CURRENCY: 'INR',
  CURRENCY_SYMBOL: '₹',
};

export const ENV_INFO = {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
  REACT_APP_API_PORT: process.env.REACT_APP_API_PORT,
  CURRENT_API_URL: API_URL,
};
